/* @generated */

// ../src/table/index.css.ts
import { createRuntimeFn as _7a468 } from "@vanilla-extract/recipes/createRuntimeFn";
var table = _7a468({ defaultClassName: "dig-cwil8c0_21-7-0", variantClassNames: { shouldStretchHeight: { true: "dig-cwil8c1_21-7-0" }, border: { collapse: "dig-cwil8c2_21-7-0", separate: "dig-cwil8c3_21-7-0" } }, defaultVariants: {}, compoundVariants: [] });
var tableBody = "dig-cwil8c4_21-7-0";
var tableCell = _7a468({ defaultClassName: "dig-cwil8cg_21-7-0", variantClassNames: { shouldStretchHeight: { true: "dig-cwil8ch_21-7-0" }, hasDivider: { true: "dig-cwil8ci_21-7-0" }, spacing: { small: "dig-cwil8cj_21-7-0", medium: "dig-cwil8ck_21-7-0", standard: "dig-cwil8cl_21-7-0", large: "dig-cwil8cm_21-7-0", xlarge: "dig-cwil8cn_21-7-0" }, valign: { top: "dig-cwil8co_21-7-0", center: "dig-cwil8cp_21-7-0", bottom: "dig-cwil8cq_21-7-0" } }, defaultVariants: {}, compoundVariants: [] });
var tableHeader = "dig-cwil8c5_21-7-0";
var tableHeaderCell = _7a468({ defaultClassName: "dig-cwil8cr_21-7-0", variantClassNames: { isNative: { true: "dig-cwil8cs_21-7-0" }, isSortable: { true: "dig-cwil8ct_21-7-0" } }, defaultVariants: {}, compoundVariants: [] });
var tableHeaderSortButton = _7a468({ defaultClassName: "dig-cwil8cc_21-7-0", variantClassNames: { isSortActive: { true: "dig-cwil8cd_21-7-0" } }, defaultVariants: {}, compoundVariants: [] });
var tableRow = _7a468({ defaultClassName: "dig-cwil8c6_21-7-0", variantClassNames: { shouldStretchHeight: { true: "dig-cwil8c7_21-7-0" }, isSelectable: { true: "dig-cwil8c8_21-7-0" }, isSelected: { true: "dig-cwil8c9_21-7-0" }, isHeader: { true: "dig-cwil8ca_21-7-0" }, hasDivider: { true: "dig-cwil8cb_21-7-0" } }, defaultVariants: {}, compoundVariants: [] });
var tableSortIcon = _7a468({ defaultClassName: "dig-cwil8ce_21-7-0", variantClassNames: { isSortActive: { true: "dig-cwil8cf_21-7-0" } }, defaultVariants: {}, compoundVariants: [] });

// ../src/table/table.tsx
import * as React9 from "react";
import classNames3 from "classnames";

// ../src/table/table_context.tsx
import * as React from "react";
var TableContext = React.createContext({
  isSelectable: false,
  hasDividers: true,
  spacing: "medium",
  verticalAlign: "center",
  isNative: false,
  borderCollapse: "collapse",
  shouldStretchHeight: true
});

// ../src/table/cell.tsx
import * as React3 from "react";
import classNames from "classnames";
import { useFirstDefined } from "@dropbox/dig-components/hooks";

// ../src/table/header_context.tsx
import * as React2 from "react";
var HeaderContext = React2.createContext({
  isHeader: false
});

// ../src/_global/sizes.tsx
var deprecationMap = [
  // [<modern-value>, <legacy-value>]
  ["medium", "standard"]
];
var getLegacyComponentSize = (size) => {
  const mapping = deprecationMap.find(([newVal, _deprecatedVal]) => size === newVal);
  if (mapping !== void 0) {
    return mapping[1];
  }
  return size;
};
var getMigratedComponentSize = (size) => {
  const mapping = deprecationMap.find(([_newVal, deprecatedVal]) => size === deprecatedVal);
  if (mapping !== void 0) {
    return mapping[0];
  }
  return size;
};

// ../src/table/cell.tsx
var Cell = React3.forwardRef(
  (props, ref) => {
    const { width, children, className, spacing, verticalAlign, ...rest } = props;
    const {
      spacing: contextSpacing,
      verticalAlign: contextVerticalAlign,
      hasDividers,
      borderCollapse
    } = React3.useContext(TableContext);
    const computedSpacing = getMigratedComponentSize(
      useFirstDefined(spacing, contextSpacing) || "medium"
    );
    const { isNative, shouldStretchHeight } = React3.useContext(TableContext);
    const { isHeader } = React3.useContext(HeaderContext);
    const computedAlignment = useFirstDefined(verticalAlign, contextVerticalAlign, "center");
    const hasDivider = borderCollapse === "separate" && (hasDividers || isHeader);
    const cellClassName = classNames(
      className,
      "dig-Table-cell",
      `dig-Table-cell--spacing-${getLegacyComponentSize(computedSpacing)}`,
      `dig-Table-cell--valign-${computedAlignment}`,
      {
        "dig-Table-cell--spacing-medium": computedSpacing === "medium",
        "dig-Table-cell--hasDivider": hasDivider
      },
      tableCell({
        shouldStretchHeight,
        spacing: getLegacyComponentSize(computedSpacing),
        valign: computedAlignment,
        hasDivider
      })
    );
    const style = width !== void 0 ? { width } : void 0;
    const TagName = React3.useMemo(() => {
      if (!isNative) {
        return "div";
      }
      if (isHeader) {
        return "th";
      }
      return "td";
    }, [isHeader, isNative]);
    const role = React3.useMemo(() => {
      if (isNative) {
        return void 0;
      }
      if (isHeader) {
        return "columnheader";
      }
      return "cell";
    }, [isHeader, isNative]);
    return /* @__PURE__ */ React3.createElement(
      TagName,
      {
        ref,
        role,
        className: cellClassName,
        ...rest,
        style: { ...style, ...rest.style }
      },
      children
    );
  }
);
Cell.displayName = "Cell";

// ../src/table/row.tsx
import * as React4 from "react";
import classNames2 from "classnames";
import { useFirstDefined as useFirstDefined2 } from "@dropbox/dig-components/hooks";
var Row = React4.forwardRef(
  (props, ref) => {
    const {
      isHeader,
      isSelectable,
      isSelected = false,
      children,
      hasDivider,
      className,
      ...rest
    } = props;
    const {
      isSelectable: contextIsSelectable,
      hasDividers: contextHasDivider,
      borderCollapse,
      shouldStretchHeight
    } = React4.useContext(TableContext);
    const { isHeader: contextIsHeader } = React4.useContext(HeaderContext);
    const computedIsHeader = useFirstDefined2(isHeader, contextIsHeader);
    const computedHasDivider = useFirstDefined2(hasDivider, contextHasDivider);
    const computedIsSelectable = useFirstDefined2(isSelectable, contextIsSelectable);
    const componentClasses = classNames2(
      className,
      "dig-Table-row",
      {
        "dig-Table-row--selectable": computedIsSelectable && !computedIsHeader,
        "dig-Table-row--selected": isSelected,
        "dig-Table-row--header": computedIsHeader,
        "dig-Table-row--hasDivider": borderCollapse === "collapse" && (computedIsHeader || computedHasDivider)
      },
      tableRow({
        shouldStretchHeight,
        isSelectable: computedIsSelectable && !computedIsHeader,
        isSelected,
        isHeader: computedIsHeader,
        hasDivider: borderCollapse === "collapse" && (computedIsHeader || computedHasDivider)
      })
    );
    const { isNative } = React4.useContext(TableContext);
    const TagName = isNative ? "tr" : "div";
    return /* @__PURE__ */ React4.createElement(TagName, { ref, role: isNative ? void 0 : "row", className: componentClasses, ...rest }, children);
  }
);
Row.displayName = "Row";

// ../src/table/header_cell.tsx
import * as React6 from "react";
import classnames2 from "classnames";

// ../src/table/table_sort_icon.tsx
import * as React5 from "react";
import { UIIcon } from "@dropbox/dig-icons";
import { ArrowDownLine, ArrowUpLine } from "@dropbox/dig-icons/assets";
import classnames from "classnames";
var TableSortIcon = ({ sortDirection }) => {
  const line = sortDirection === "asc" ? ArrowUpLine : ArrowDownLine;
  const componentClasses = classnames(
    "dig-Table-sort-icon",
    {
      "dig-Table-sort-icon--sort-active": sortDirection && sortDirection !== "none"
    },
    tableSortIcon({
      isSortActive: sortDirection && sortDirection !== "none"
    })
  );
  return /* @__PURE__ */ React5.createElement(UIIcon, { className: componentClasses, role: "presentation", size: "small", src: line });
};
TableSortIcon.displayName = "TableSortIcon";

// ../src/table/header_cell.tsx
import "focus-visible";
var HeaderCell = ({
  children,
  className,
  onSort,
  sortDirection,
  ...rest
}) => {
  const isSortable = sortDirection !== void 0;
  const { isNative } = React6.useContext(TableContext);
  const componentClasses = classnames2(
    className,
    "dig-Table-header-cell",
    {
      "dig-Table-header-cell--isNative": isNative,
      "dig-Table-header-cell--isSortable": isSortable,
      "dig-Table-header-cell--isSorted": isSortable && sortDirection !== "none"
    },
    tableHeaderCell({
      isNative,
      isSortable
    })
  );
  const ariaSort = React6.useMemo(() => {
    switch (sortDirection) {
      case "asc":
        return "ascending";
      case "desc":
        return "descending";
      default:
        return void 0;
    }
  }, [sortDirection]);
  const SortButton = React6.useMemo(
    () => /* @__PURE__ */ React6.createElement(
      "button",
      {
        onClick: onSort,
        className: classnames2(
          "dig-Table-header-sort-button",
          {
            "dig-Table-header-sort-button--sort-active": sortDirection !== "none"
          },
          tableHeaderSortButton({ isSortActive: sortDirection !== "none" })
        )
      },
      /* @__PURE__ */ React6.createElement("span", null, children),
      /* @__PURE__ */ React6.createElement(TableSortIcon, { sortDirection })
    ),
    [children, onSort, sortDirection]
  );
  return /* @__PURE__ */ React6.createElement(Cell, { className: componentClasses, "aria-sort": ariaSort, ...rest }, !isSortable && children, isSortable && SortButton);
};
HeaderCell.displayName = "HeaderCell";

// ../src/table/header.tsx
import * as React7 from "react";
import classnames3 from "classnames";
var Header = React7.forwardRef(
  (props, ref) => {
    const { className, children, ...rest } = props;
    const componentClasses = classnames3(className, "dig-Table-header", tableHeader);
    const { isNative } = React7.useContext(TableContext);
    const TagName = isNative ? "thead" : "div";
    return /* @__PURE__ */ React7.createElement(HeaderContext.Provider, { value: { isHeader: true } }, /* @__PURE__ */ React7.createElement(
      TagName,
      {
        ref,
        role: isNative ? void 0 : "rowgroup",
        className: componentClasses,
        ...rest
      },
      children
    ));
  }
);
Header.displayName = "Header";

// ../src/table/body.tsx
import * as React8 from "react";
import classnames4 from "classnames";
var Body = ({
  className,
  children,
  ...rest
}) => {
  const componentClasses = classnames4("dig-Table-body", tableBody, className);
  const { isNative } = React8.useContext(TableContext);
  const TagName = isNative ? "tbody" : "div";
  return /* @__PURE__ */ React8.createElement(TagName, { role: isNative ? void 0 : "rowgroup", className: componentClasses, ...rest }, children);
};
Body.displayName = "Body";

// ../src/table/table.tsx
var TableRef = React9.forwardRef((props, ref) => {
  const {
    spacing: _spacing = "medium",
    hasDividers = true,
    isSelectable = false,
    children,
    verticalAlign,
    className,
    isNative = false,
    borderCollapse = "collapse",
    shouldStretchHeight = true,
    ...rest
  } = props;
  const spacing = getMigratedComponentSize(_spacing);
  const componentClasses = classNames3(
    className,
    "dig-Table",
    `dig-Table--${getLegacyComponentSize(spacing)}`,
    `dig-Table--border-${borderCollapse === "collapse" ? "collapse" : "separate"}`,
    {
      "dig-Table--medium": spacing === "medium",
      "dig-Table--isSelectable": isSelectable,
      "dig-Table--hasDividers": hasDividers
    },
    table({
      border: borderCollapse,
      shouldStretchHeight
    })
  );
  return /* @__PURE__ */ React9.createElement(
    TableContext.Provider,
    {
      value: {
        isSelectable,
        hasDividers,
        spacing,
        verticalAlign,
        isNative,
        borderCollapse,
        shouldStretchHeight
      }
    },
    isNative ? /* @__PURE__ */ React9.createElement(
      "table",
      {
        cellSpacing: 0,
        cellPadding: 0,
        className: componentClasses,
        ...rest,
        ref
      },
      children
    ) : /* @__PURE__ */ React9.createElement(
      "div",
      {
        role: "table",
        className: componentClasses,
        ...rest,
        ref
      },
      children
    )
  );
});
TableRef.displayName = "Table";
var Table = Object.assign({}, TableRef, {
  Cell,
  Row,
  HeaderCell,
  Header,
  Body
});
export {
  Table
};
